import {
  ServiceHealthNotificationSubscriptionCreate,
  ServiceHealthNotificationSubscriptionResponse,
  ServiceHealthNotificationSubscriptionUnsubscribe,
} from '@/types/service/serviceHealthNotificationSubscription';

import { basePublicApi } from '@/store/baseApi';

export const serviceHealthNotificationSubscriptionApi = basePublicApi.injectEndpoints({
  endpoints: (builder) => ({
    subscribeToNotifications: builder.mutation<
      ServiceHealthNotificationSubscriptionResponse,
      ServiceHealthNotificationSubscriptionCreate
    >({
      query: (data) => ({
        url: '/v1/service-health-notification-subscriptions',
        method: 'POST',
        data,
      }),
    }),
    unsubscribeFromNotifications: builder.mutation<
      ServiceHealthNotificationSubscriptionResponse,
      ServiceHealthNotificationSubscriptionUnsubscribe
    >({
      query: (data) => ({
        url: '/v1/service-health-notification-subscriptions',
        method: 'DELETE',
        data,
      }),
    }),
  }),
});

export const { useSubscribeToNotificationsMutation, useUnsubscribeFromNotificationsMutation } =
  serviceHealthNotificationSubscriptionApi;
